import LifeInsuranceGuard from "./LifeInsurance_Guard";
import { lazy, Suspense } from "react";
import LoadingInstant from "../../pages/Utilities/LoadingInstant";
import { R_LiRoutes } from "../../utils/Routes";
import SuspenseWrapper from "../../components/CustomLazyLoading/CustomLazyLoading";

const TaxCertificate = lazy(() => import("./TaxCertificate/TaxCertificate"));
const PolicyAccountStatement = lazy(
  () => import("./PolicyAccountStatement/PolicyAccountStatement")
);
const DetailsPage = lazy(
  () => import("../Feature_LifeInsurance/DetailsPage/DetailsPage")
);
const PremiumReceipt = lazy(() => import("./PremiumReceipt/PremiumReceipt"));
const AddUpdateNominee = lazy(
  () => import("./AddUpdateNominee/AddUpdateNominee")
);
const UpdatePAN = lazy(() => import("./UpdatePAN/UpdatePAN"));
const AddUpdateBankAccount = lazy(
  () => import("./AddUpdateBankAccount/AddUpdateBankAccount")
);
const SetAlerts = lazy(() => import("./SetAlerts/SetAlerts"));
const UnableToNavigate = lazy(
  () => import("../../pages/UnableToNavigate/UnableToNavigate")
);
const LifeInsuranceRoutesFn = () => {
  return [
    {
      path: R_LiRoutes.li_baseUrl,
      element: <LifeInsuranceGuard />,
      children: [
        {
          path: R_LiRoutes.details_PolicyNumber,
          element: <SuspenseWrapper LazyLoadingComponent={DetailsPage} />,
        },
        {
          path: R_LiRoutes.details_PolicyNumber_TaxCertificate,
          element: <SuspenseWrapper LazyLoadingComponent={TaxCertificate} />,
        },
        {
          path: R_LiRoutes.details_PolicyNumber_PolicyAccountStatement,
          element: (
            <SuspenseWrapper LazyLoadingComponent={PolicyAccountStatement} />
          ),
        },
        {
          path: R_LiRoutes.details_PolicyNumber_PremiumReceipts,
          element: <SuspenseWrapper LazyLoadingComponent={PremiumReceipt} />,
        },
        {
          path: R_LiRoutes.addUpdate_nominee,
          element: <SuspenseWrapper LazyLoadingComponent={AddUpdateNominee} />,
        },
        {
          path: R_LiRoutes.details_PolicyNumber_UpdatePAN,
          element: <SuspenseWrapper LazyLoadingComponent={UpdatePAN} />,
        },
        {
          path: R_LiRoutes.detail_PolicyNumber_AddUpdateBankAccount,
          element: (
            <SuspenseWrapper LazyLoadingComponent={AddUpdateBankAccount} />
          ),
        },
      ],
    },
    {
      path: R_LiRoutes.details_set_alerts,
      element: <SuspenseWrapper LazyLoadingComponent={SetAlerts} />,
    },
    {
      path: R_LiRoutes.li_UrlNotFound,
      element: <SuspenseWrapper LazyLoadingComponent={UnableToNavigate} />,
    },
  ];
};
export { LifeInsuranceRoutesFn };
